import styled from "styled-components";

export const Diferencas = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    #div-one {
      display: flex;
      flex-direction: column;
      background-color: var(--blue-white);
      padding: 43px;
      gap: 40px;
      margin: 0 auto;
      width: 100%;
      align-items: center;

      #subtitle {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--title);
      }

      article {
        display: flex;
        flex-direction: column;
        gap: 30px;

        p {
          position: relative;

          .icon-checked {
            font-size: 20px;
            color: #23c450;
            margin-right: 5px;
            position: absolute;
          }

          p {
            font-size: 14px;
            line-height: 160%;
            margin-left: 30px;
          }
          span {
            color: var(--orange);
            font-weight: 700;
          }
        }
      }
    }

    #div-two {
      display: flex;
      flex-direction: column;
      padding: 43px;
      margin: 0 auto;

      #span-pq {
        font-weight: 700;
        font-size: 12px;
        line-height: 122%;
        text-transform: uppercase;
        color: var(--orange);
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
        margin-bottom: 30px;
      }

      #h1-mobile {
        display: flex;
      }

      #h1-desktop {
        display: none;
      }

      p {
        font-size: 14px;
        line-height: 160%;
        color: var(--paragraph);

        span {
          font-weight: 700;
        }
      }

      #button-desktop {
        display: none;
      }
    }
  }

  @media (min-width: 601px) {
    height: 827px;
    #pather-div {
      display: flex;
      flex-direction: row;
      align-items: center;

      #div-one {
        background-color: var(--white);
        align-items: flex-start;

        #subtitle {
          font-size: 16px;
        }

        article p p {
          font-size: 16px;
        }

        #button-mobile {
          display: none;
        }
      }

      #div-two {
        background-color: var(--white);

        #span-pq {
          font-size: 16px;
        }

        h1 {
          font-size: 40px;
        }

        #h1-mobile {
          display: none;
        }

        #h1-desktop {
          display: flex;
        }

        p {
          font-size: 16px;
        }

        #button-desktop {
          display: flex;
          margin: 30px 0;
        }
      }
    }
  }
`;

export const Button = styled.button`
  width: ${(props) => props.w};
  height: ${(props) => props.h};

  border: none;
  border-radius: 2px;
  background-color: var(--blue);

  display: flex;
  align-items: center;
  justify-content: center;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => props.w};
    height: ${(props) => props.h};
    color: var(--white);
    font-weight: 500;
    font-size: ${(props) => props.s};
    line-height: 150%;

    svg {
      font-size: ${(props) => props.icon};
      margin-left: 5px;
    }
  }
`;
